export { DataGrid, type DataGridProps } from './data-grid';
export { DataGridToolbar, type DataGridToolbarProps } from './data-grid-toolbar';
export {
  DataGridFilterControls,
  type DataGridFilterControlsProps,
} from './data-grid-filter-controls';
export {
  DataGridColumnControls,
  DENSITY_ROW_CLASSES,
  DENSITY_ROW_HEIGHT_PX,
  type DataGridColumnControlsProps,
  type DataGridDensity,
} from './data-grid-column-controls';
export {
  DataGridSavedViews,
  type DataGridSavedViewsProps,
  type SavedView,
} from './data-grid-saved-views';
// `buildCsv` + `downloadCsv` are intentionally NOT re-exported from
// the package root (`packages/ui/src/index.ts`) — there's an older
// `downloadCsv(filename, headers, rows)` helper exported from
// `./utils/download` with a different signature, and a duplicate
// would silently shadow it. Consumers that need the DataGrid CSV
// builder should import deeply: `@statura/ui/components/data-grid`
// (or replicate the logic on the audited path in
// `apps/web/src/lib/csv-export.ts`).
export { buildCsv, downloadCsv as downloadGridCsv } from './csv-export';
export type {
  ActiveFilters,
  DataGridBulkAction,
  DataGridColumn,
  DataGridEmptyState,
  DataGridSelection,
  FilterSpec,
} from './types';
